export default {
  contacts: ({ contacts }) => contacts,
};
